import globals from "../partials/global-variables";
import { ButtonPrimary, ButtonNextInProgress } from "../partials/buttons";
import stylesConfig from "../styles.config";
import mediaQuery from "../abstract/media-query";

export default {
  "@keyframes navigationSpinner": {
    "0%": {
      transform: "translate(-50%,-50%) rotate(0deg)",
    },
    "100%": {
      transform: "translate(-50%,-50%) rotate(360deg)",
    },
  },
  container: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    width: "100%",
    paddingBottom: "25px",
    borderBottom: "1px solid",
    borderColor: stylesConfig.colors.secondary.spectrum100,
    [`@media (${globals.breakpoints.$xs})`]: {
      paddingBottom: "15px",
    },
    ".top-navigation &": {
      flex: "1 1 auto",
      width: "auto",
      paddingBottom: 0,
      borderBottom: 0,
      order: -1,
      [`@media (${globals.breakpoints.$xs})`]: {
        flex: "0 1 auto",
        width: "calc(50% - 8px)",
      },
    },
    "& .navigation-back-button": {
      ...ButtonPrimary,
      marginRight: "15px",
      background: stylesConfig.colors.secondary.spectrum100,
      borderColor: stylesConfig.colors.secondary.spectrum100,
      color: stylesConfig.colors.primaryFontColor,
      "&:before": {
        content: "' '",
        position: "absolute",
        display: "inline-block",
        width: "10px",
        height: "3px",
        borderRadius: "3px",
        backgroundColor: stylesConfig.colors.primaryFontColor,
        transform: "rotate(45deg)",
        left: "20px",
        top: "calc(50% + 1px)",
      },
      "&:after": {
        content: "' '",
        position: "absolute",
        display: "inline-block",
        width: "10px",
        height: "3px",
        borderRadius: "3px",
        backgroundColor: stylesConfig.colors.primaryFontColor,
        transform: "rotate(-45deg)",
        left: "20px",
        top: "calc(50% - 4px)",
      },
      [mediaQuery.hover]: {
        "&:hover": {
          background: stylesConfig.colors.secondary.spectrum200,
        },
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        marginRight: "10px",
        order: 1,
        width: "calc(50% - 5px)",
        paddingLeft: 0,
        paddingRight: 0,
        minWidth: "45%",
      },
      "[data-advisor-mode='RESULTS_PAGE'] &": {
        [`@media (${globals.breakpoints.$xs})`]: {
          width: "100%",
        },
      },
      ".top-navigation &": {
        width: "auto",
        marginRight: 0,
      },
    },
    "& .navigation-next-button, & .navigation-submit-button": {
      ...ButtonPrimary,
      marginRight: 0,
      marginLeft: "auto",
      position: "relative",
      "&:before": {
        content: "' '",
        position: "absolute",
        display: "inline-block",
        width: "10px",
        height: "3px",
        borderRadius: "3px",
        backgroundColor: stylesConfig.colors.secondaryFontColor,
        transform: "rotate(-45deg)",
        right: "20px",
        top: "calc(50% + 1px)",
      },
      "&:after": {
        content: "' '",
        position: "absolute",
        display: "inline-block",
        width: "10px",
        height: "3px",
        borderRadius: "3px",
        backgroundColor: stylesConfig.colors.secondaryFontColor,
        transform: "rotate(45deg)",
        right: "20px",
        top: "calc(50% - 4px)",
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        order: 2,
        width: "calc(50% - 5px)",
        paddingLeft: 0,
        paddingRight: 0,
        minWidth: "45%",
      },
    },
    "& .navigation-next-in-progress": {
      ...ButtonNextInProgress,
      marginLeft: "auto",
    },
  },
};
